module.exports = __webpack_public_path__ + "changelog-point-92ad67e0f87556781cf936bc091e5b69.png";